import { TabStyles } from '@tableau/widgets';

import { SpaceBetweenCardsInPx } from '../../app/spaces/CardView/CardView';
import { TOTAL_CARD_HEIGHT, TOTAL_CARD_WIDTH } from '../../app/spaces/CardView/CardViewStyles';
import { cssClass } from '../../style';

export namespace ChannelStyles {
  const channelPrefix = 'Channel';
  const boxShadowHeightInPx = 2;

  export const cardHeight = TOTAL_CARD_HEIGHT + SpaceBetweenCardsInPx;
  export const horizontalMarginBetweenCards = 32;
  export const cardBorder = 2;  // 2 px to account for the border on the left from the shadow

  export const cardDimensions = cssClass(channelPrefix, 'cardDimensions', {
    height: TOTAL_CARD_HEIGHT,
    width: TOTAL_CARD_WIDTH,
    marginRight: horizontalMarginBetweenCards,
    marginTop: 18,
    marginLeft: 2,
  });

  export const cardsContainer = cssClass(channelPrefix, 'cards-container', {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'start',
    overflow: 'hidden',
    paddingBottom: boxShadowHeightInPx,
    marginRight: -horizontalMarginBetweenCards,
  });

  export const header = cssClass(channelPrefix, 'header', {
    borderBottom: `1px ${TabStyles.Colors.L3} solid`,
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 2,
    paddingBottom: 8,
    $nest: {
      '& h2': {
        fontWeight: 'normal',
        fontSize: TabStyles.Typography.Sizing.XLarge,
        color: TabStyles.Colors.L9,
        lineHeight: '21px',
        margin: 0,
        position: 'relative',
        left: 4
      },
      '& a': {
        marginRight: 4,
        position: 'relative',
        bottom: -3,
        right: 4,
        cursor: 'pointer'
      }
    }
  });

  export const channelSectionMargins = cssClass(channelPrefix, 'channel-section-margins', {
    margin: '0 24px 0'
  });

  export const showMoreButtonContainer = cssClass(channelPrefix, 'show-more-button-container', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 15,
    paddingBottom: 15
  });

  export const headerIcon = cssClass(channelPrefix, 'header-icon', {
    position: 'relative',
    top: 2,
    marginRight: 5
  });
}

export namespace TextChannelStyles {
  const textChannelPrefix = 'TextChannel';
  export const text = cssClass(textChannelPrefix, 'text', {
    position: 'relative',
    left: 4,
    fontSize: 14,
    lineHeight: '21px',
    marginTop: 20,
    marginBottom: 0
  });
}
